import {TrackDateModelState} from '../types';

export function isTrackDatesValid(trackDates: TrackDateModelState[]) {
	return trackDates.every(({dateFrom, dateTo}) => dateFrom.value && !dateFrom.error && dateTo.value && !dateTo.error);
}
